import * as React from 'react';
import {
  Datagrid,
  DateField,
  List,
  SimpleShowLayout,
  TextField,
  usePermissions,
  TextInput, NumberField, TopToolbar, Show, useRecordContext, useUpdate, useGetOne, Loading, Error, BooleanField, DeleteButton,
} from "react-admin";
import CreateView from "../../../components/CreateView";
import { CreateTemplateButton } from './CreateTemplateButton';
import { ROLES } from '../../../constants';


  const formatNumber = inputNumber => {
    let formetedNumber = (Number(inputNumber)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    let splitArray = formetedNumber.split('.');
    if (splitArray.length > 1) {
      formetedNumber = splitArray[0];
    }
    return (formetedNumber);
  };

const ListActions = (props) => {

  return (
    <TopToolbar>
      {/* <CreateButton onClick={(e) => {e.preventDefault();e.stopPropagation();
       handleClick(); 
  }}
    /> */}
      <CreateTemplateButton />
    </TopToolbar>
  )
};
const FormattedNumberField = ({ source, label }) => {
  const record = useRecordContext();
  if (!record) return null;
  return (
    <TextField
      source={source}
      label={label}
      render={record => formatNumber(record[source])}
    />
  );
};
const BalanceField = (props) => {
  const record = useRecordContext(props);
  if (!record) return null;
  return <span>{formatNumber(record.balanceReceived)}</span>;
};

export const PaybillsList = (props) => {
  const { permissions } = usePermissions();
  return (

    <List {...props} perPage={100} actions={null} sort={{ field: 'createdAt', order: 'DESC' }} 
   

    >
      <Datagrid rowClick="show" >
        {/* <DateField  locales={"fa-IR"} source="createdAt" /> */}
        <NumberField source="month" />
        <TextField source="year" />
        <TextField source="userNumber" />
        <TextField source="userName" />
<BalanceField label="مانده دریافتی" />

        <BooleanField source="readAndAgreeByUser" />
        <DateField source="readAndAgreeByUserDate" locales={"fa-IR"} options={{ weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }} />
        <TextField source="description" />
        {(permissions?.includes(ROLES.SUPER_ADMIN)
          || permissions?.includes(ROLES.HR_ADMIN) || permissions?.includes(ROLES.ROOT)) &&

          <DeleteButton />
        }
      </Datagrid>
    </List>
  )
};

const tableStyle = {
  'width': '100%',
  'borderCollapse': 'collapse',
  'borderTop': 'none',
  'tableLayout': 'fixed',
}
const trStyle = { 'backgroundColor': '#adacac', color: '#10100f', 'textAlign': 'center', 'fontSize': '24px', 'fontWeight': '600', 'lineHeight': '30px' }
const thStyle = { 'backgroundColor': '#a19f9f', 'color': '#10100f', 'textAlign': 'center', 'lineHeight': '30px' }
const tdStyle = { 'backgroundColor': '#f3f0f0', 'color': '#10100f', 'lineHeight': '30px', 'textAlign': 'center', }

export const PaybillsShow = (props) => {
  const { permissions } = usePermissions();

  const { data: pb, isLoading, error } = useGetOne('paybills', props.id);

  const [agree, setAgree] = React.useState(false);

  const [visiblePaybill, setVisiblePaybill] = React.useState(false);

  const checkboxHandler = () => {
    setAgree(!agree);
  }
  const handleClick = () => {
    setVisiblePaybill(true)
  };
  if (isLoading) return <Loading />;
  if (error) return <Error />;
  return (

    <Show emptyWhileLoading variant="outlined" {...props} actions={<ListActions />}  >
      <SimpleShowLayout>


        {((!visiblePaybill && !pb?.readAndAgreeByUser)) && <div className="message-container">
          <TextField class="message-bill" source="commentBeforeBill" />
          <p className="message-text">متن را خواندم و قبول دارم<input className="checkbox-bill" type="checkbox" id="agree" onChange={checkboxHandler} /></p>

          {agree && <ShowPaybillsButton handleClick={handleClick} />}
        </div>}



        {((visiblePaybill || pb?.readAndAgreeByUser) || (permissions?.includes(ROLES.SUPER_ADMIN)
          || permissions?.includes(ROLES.ROOT))) && <div id='styledTable'>
            <table style={tableStyle} >

              <tr height="100px"
                style={trStyle}>
                <th></th>
                <td colSpan={1} style={{ width: '25%', textAlign: 'left' }}>فیش حقوقی <TextField source="userName" />  - <TextField source="year" />/<TextField source="month" /></td>
                <td></td>
              </tr>
              <tr>
                <th style={thStyle}>کد پرسنلی </th>
                <td style={tdStyle}><TextField source="userNumber" /></td>
                <th style={thStyle}>نام</th>
                <td style={tdStyle}><TextField source="userName" /></td>
              </tr>
              <tr>
                <th style={thStyle}>سال</th>
                <td style={tdStyle}><TextField source="year" /></td>
                <th style={thStyle}>ماه</th>
                <td style={tdStyle}><TextField source="month" /></td>
              </tr>
              <tr>
                <th style={thStyle}>تعداد روز کارکرد</th>
                <td style={tdStyle}><TextField source="numberOfWorkingDays" /></td>
                <th style={thStyle}>تعداد ساعت کارکرد</th>
                <td style={tdStyle}><TextField source="numberOfWorkingHours" /></td>
              </tr>
              <tr>
                <th style={thStyle}>تعداد ساعت اضافه کاری</th>
                <td style={tdStyle}><TextField source="numberOfAdditionalWorkHours" /></td>
                <th style={thStyle}>تعداد ساعت کسر کار</th>
                <td style={tdStyle}><TextField source="numberOfUnderWorkHours" /></td>
              </tr>
              <tr>
                <th style={thStyle}>حق تاهل</th>
                <td style={tdStyle}>{formatNumber(pb.haghTahol)}</td>
                <th style={thStyle}>مرخصی (تعداد روز )</th>
                <td style={tdStyle}><TextField source="leave" /></td>
              </tr>
              <tr>
                <th style={thStyle}>تعطیلات رسمی (تعداد روز )</th>
                <td style={tdStyle}><TextField source="officialHolidays" /></td>
                <th style={thStyle}>شماره حساب</th>
                <td style={tdStyle}><TextField source="iban" /></td>
              </tr>
              <tr>
                <th style={thStyle}>پایه سنوات (به ریال)</th>
                <td style={tdStyle}>{pb.baseYearsSalary}</td>
                <td style={tdStyle}></td>
                <td style={tdStyle}></td>

              </tr>

            </table>
            <table style={tableStyle}>
              <tr>
                <th style={thStyle}>پایه حقوق روزانه (به ریال)</th>
                <td style={tdStyle}>{formatNumber(pb.basicDailySalary)}</td>
                <th style={thStyle}>مساعده دریافتی (به ریال)</th>
                <td style={tdStyle}>{formatNumber(pb.assistanceReceived)}</td>
              </tr>
              <tr>
                <th style={thStyle}>مبلغ عیدی و سنوات و مانده مرخصی (به ریال)</th>
                <td style={tdStyle}>{formatNumber(pb.holidaysAndBaseYearandLeaveBalance)}</td>
                <th style={thStyle}>کارانه (به ریال)</th>
                <td style={tdStyle}>{formatNumber(pb.lunch)}</td>
              </tr>
              <tr>
                <th style={thStyle}> مبلغ پاداش ( به ریال)</th>
                <td style={tdStyle}>{formatNumber(pb.reward)}</td>
                <th style={thStyle}>مبلغ خرید (به ریال)</th>
                <td style={tdStyle}>{formatNumber(pb.buy)}</td>
              </tr>
              <tr>
                <th style={thStyle}>حقوق ماه (به ریال)</th>
                <td style={tdStyle}><span>{formatNumber(pb.monthlySalary)}</span></td>
                <th style={thStyle}>قسط وام (به ریال)</th>
                <td style={tdStyle}>{formatNumber(pb.loan)}</td>
              </tr>
              <tr>
                <th style={thStyle}>کسر حق بیمه سهم کارپذیر (به ریال)</th>
                <td style={tdStyle}>{formatNumber(pb.insuranceDeduction)}</td>
                <th style={thStyle}>سایر کسورات ( به ریال)</th>
                <td style={tdStyle}>{formatNumber(pb.otherDeductions)}</td>

              </tr>
              <tr>
                <th style={thStyle}>مبلغ بدهی قبلی ( به ریال)</th>
                <td style={tdStyle}>{formatNumber(pb.previousDebt)}</td>
                <th style={thStyle}>حق اولاد (به ریال)</th>
                <td style={tdStyle}>{formatNumber(pb.childAllowance)}</td>

              </tr>
              <tr>
                <th style={thStyle}>توضیحات</th>
                <td style={tdStyle}><TextField source="description" /></td>
                <td style={tdStyle}></td>
                <td style={tdStyle}></td>

              </tr>
              <tr>
                <th style={thStyle}>مانده دریافتی ( به ریال)</th>
                <td style={tdStyle}>{formatNumber(pb.balanceReceived)}</td>

                <td style={tdStyle}>امضا مدیر مالی</td>
                <td style={tdStyle}> امضا همکار</td>
              </tr>
              <tr>
                <td style={tdStyle}></td>
                <td style={tdStyle}></td>
                <td style={tdStyle}></td>
                <td style={tdStyle}></td>

              </tr>
            </table>
          </div>
        }
      </SimpleShowLayout>
    </Show >
  )
};

export const PaybillsCreate = (props) => (
  <CreateView {...props}>
    <TextInput source="order" label="ترتیب" />
    <TextInput source="title" label="عنوان" />
  </CreateView>
);

const ShowPaybillsButton = (props) => {
  const record = useRecordContext();
  // if(!record) return null;
  const diff = { readAndAgreeByUser: true, paybillsId: record.id };
  const [update, { isLoading, error }] = useUpdate('paybills', record.id, diff);
  const handleClick = () => {

    update()
    props.handleClick(true)
  }
  if (error) console.log('inja error', error)
  return <button disabled={isLoading} onClick={handleClick} className="accept-button">نمایش فیش حقوقی</button>;
};



